<template>
    <div class="container">
        <div class="col-md-4 ml-auto mr-auto text-center">
            
            <div class="game-icon">
                <img :src="icon" style="width: 80%; margin-bottom: 32px;box-shadow: rgba(86, 86, 86, 0.56) 0px 9px 20px 3px"> 
            </div>

            <h1>COMING SOON!</h1>
        </div>
    </div>
</template>

<script>
    export default {
        beforeCreate () {
        },
        created () {
        },
        props: {
            // required
            icons: { type: Array, required : true },
        },
        data() {
            return {
                icon: this.icons[0],
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="scss" scoped>
    .game-icon {
        margin-top: 50%;

        img {
            width: 50%;
            border-radius: 32px;
            object-fit: contain;
        }
    }

    .title {
        font-weight: bold!important;
    }

    .mt-space {
        margin-top: 32px;
    }

    .drop-shadow {
        box-shadow: 0px 5px 6px 0px #00000066

    }

</style>


// WEBPACK FOOTER //
// src/components/views/Landing.vue